import React from "react";
import { MapPin, Globe, Camera, ShieldCheck, Info } from "lucide-react";

const CreateProgramPage = () => {
  return (
    <div className="space-y-10 pb-20">
      <section>
        <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-purple-50 border border-purple-100 mb-4">
          <Globe size={14} className="text-purple-600" />
          <span className="text-[10px] font-black text-purple-600 uppercase tracking-widest">Marketplace Identity</span>
        </div>
        <h1 className="text-4xl font-black text-gray-900 tracking-tight mb-4">Program Profile</h1>
        <p className="text-lg text-gray-600 max-w-2xl leading-relaxed">
          Establish your organization's headquarters. This information is used to place your 
          program on the Nuvio Map and connect you with local athletes.
        </p>
      </section>

      {/* Discovery Importance Alert */}
      <div className="bg-amber-50 border border-amber-200 rounded-2xl p-6 flex gap-4 items-start">
        <MapPin className="text-amber-600 flex-shrink-0" size={24} />
        <div>
          <h4 className="font-bold text-amber-900">Why the address matters</h4>
          <p className="text-sm text-amber-800 leading-relaxed">
            Nuvio Sport uses a <strong>Geographical Discovery Engine</strong>. When athletes search for 
            "Programs near me," our system calculates the distance from their home to your address. 
            Without a verified location, your program will not appear in local search results.
          </p>
        </div>
      </div>

      <div className="grid md:grid-cols-2 gap-8">
        {/* Profile Branding Mockup */}
        <div className="space-y-6">
          <div className="bg-white border border-gray-100 p-8 rounded-3xl shadow-sm">
            <h3 className="text-xl font-bold text-gray-900 mb-6">Branding & Logo</h3>
            <div className="flex flex-col items-center justify-center border-2 border-dashed border-gray-200 rounded-2xl p-10 bg-gray-50 group hover:border-purple-400 transition-colors cursor-pointer">
              <Camera className="text-gray-400 group-hover:text-purple-500 mb-2" size={32} />
              <p className="text-xs font-bold text-gray-500 uppercase">Upload Program Logo</p>
            </div>
          </div>
        </div>

        {/* Location Form Mockup */}
        <div className="bg-white border border-gray-100 p-8 rounded-3xl shadow-sm space-y-5">
          <h3 className="text-xl font-bold text-gray-900">Official Location</h3>
          <div className="space-y-4">
            <div className="space-y-2">
              <label className="text-[10px] font-black text-gray-400 uppercase tracking-widest">Street Address</label>
              <div className="w-full h-12 bg-gray-50 rounded-xl border border-gray-100"></div>
            </div>
            <div className="grid grid-cols-2 gap-4">
               <div className="space-y-2">
                <label className="text-[10px] font-black text-gray-400 uppercase tracking-widest">City</label>
                <div className="w-full h-12 bg-gray-50 rounded-xl border border-gray-100"></div>
              </div>
              <div className="space-y-2">
                <label className="text-[10px] font-black text-gray-400 uppercase tracking-widest">State/Zip</label>
                <div className="w-full h-12 bg-gray-50 rounded-xl border border-gray-100"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CreateProgramPage;